export default {
  data: [
    {
      id: 1,
      articleName: "Cilindro demo 1",
      isPrototype: false,
      grade: 1,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 600,
            radius: 75
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 30,
      hardness_required: 700,
      date: "2020-02-10T13:52:38+01:00"
    },
    {
      id: 2,
      articleName: "Cilindro demo 2",
      isPrototype: false,
      grade: 1,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 400,
            radius: 100
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 50,
      hardness_required: 780,
      date: "2020-02-10T17:52:38+01:00"
    },
    {
      id: 3,
      articleName: "Eje de coche",
      isPrototype: true,
      grade: 3,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 200,
            radius: 30
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 35,
      hardness_required: 780,
      date: "2020-02-10T18:52:38+01:00"
    },
    {
      id: 4,
      articleName: "Anilla",
      isPrototype: false,
      grade: 2,
      figure: [
        {
          name: "torus",
          values: {
            radius: 400,
            tube: 100
          }
        }
      ],
      selected_figure: "torus",
      hard_coat: 30,
      hardness_required: 800,
      date: "2020-01-06T13:43:38+01:00"
    },
    {
      id: 5,
      articleName: "Eje generador eólico",
      isPrototype: false,
      grade: 3,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 1500,
            radius: 500
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 20,
      hardness_required: 700,
      date: "2020-02-10T13:52:38+01:00"
    },
    {
      id: 6,
      articleName: "Biga",
      isPrototype: true,
      grade: 1,
      figure: [
        {
          name: "rectangle",
          values: {
            width: 400,
            height: 400,
            length: 2000
          }
        }
      ],
      selected_figure: "rectangle",
      hard_coat: 35,
      hardness_required: 800,
      date: "2020-01-08T13:40:38+01:00"
    },
    {
      id: 7,
      articleName: "Biga vertical",
      isPrototype: true,
      grade: 2,
      figure: [
        {
          name: "rectangle",
          values: {
            width: 400,
            height: 600,
            length: 3000
          }
        }
      ],
      selected_figure: "rectangle",
      hard_coat: 38,
      hardness_required: 900,
      date: "2020-01-20T13:40:38+01:00"
    },
    {
      id: 8,
      articleName: "Perno para sujeción off-shore",
      isPrototype: false,
      grade: 2,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 400,
            radius: 20
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 20,
      hardness_required: 790,
      date: "2020-02-11T12:52:38+01:00"
    },
    {
      id: 9,
      articleName: "Eje generador eólico 2",
      isPrototype: false,
      grade: 2,
      figure: [
        {
          name: "cylinder",
          values: {
            height: 3000,
            radius: 500
          }
        }
      ],
      selected_figure: "cylinder",
      hard_coat: 25,
      hardness_required: 750,
      date: "2020-02-11T13:52:38+01:00"
    }
  ]
};
